import result from 'proton-account/src/pages/forgot-username';
import type { Parameters } from 'proton-account/src/pages/interface';

const data = (): Parameters => ({
    ...result(),
});

export default data;
